import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL!;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY!;

// Single client — anon key for everything
// RLS policies handle permissions
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Alias for backward compat — same client
export const supabaseAdmin = supabase;
